import type { Technique } from '../types';
import { SOFT_BODY_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type SoftBodyState } from './render';

export const softBody: Technique<SoftBodyState> = {
  id: 'soft-body',
  name: 'Soft-Body-Text',
  category: 'physics',
  description: 'Die Buchstaben als Feder-Masse-Netz, das durchhängt, sich dehnt und im Wind schwingt.',
  params: SOFT_BODY_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
